import type { AnyAction } from 'redux';
import { combineReducers } from 'redux';

import {
    markAnnouncementViewed,
    setAnnouncementsUnreadCount,
    setLoadingAnnouncements,
    storeAnnouncements,
} from 'js/src/data/announcements/announcement-actions';
import type { ReadonlyAnnouncement } from 'js/src/data/announcements/announcement-types';

const NO_ANNOUNCEMENTS: readonly ReadonlyAnnouncement[] = [];

function list(
    state: readonly ReadonlyAnnouncement[] = NO_ANNOUNCEMENTS,
    action: AnyAction,
): readonly ReadonlyAnnouncement[] {
    if (storeAnnouncements.match(action)) {
        return action.payload.announcements;
    }
    if (markAnnouncementViewed.match(action)) {
        const { announcementId } = action.payload;
        const needsUpdate = state.some((a) => a.id === announcementId && !a.is_viewed);
        if (needsUpdate) {
            return state.map((a) => (a.id === announcementId ? { ...a, is_viewed: true } : a));
        }
    }
    return state;
}

function isLoading(state = false, action: AnyAction): boolean {
    if (setLoadingAnnouncements.match(action)) {
        return action.payload.isLoading;
    }
    return state;
}

function unreadCount(state = 0, action: AnyAction): number {
    if (setAnnouncementsUnreadCount.match(action)) {
        return action.payload.count;
    }
    return state;
}

export const announcements = combineReducers({
    list,
    isLoading,
    unreadCount,
});

export type AnnouncementsState = ReturnType<typeof announcements>;
